import React from 'react';
import styled from 'styled-components';

const logoBlack = require('../../assets/CDKGlobalWM_BLK.jpg');
const logoWhite = require('../../assets/CDKGlobalWM_WHT.jpg');

const CdkLogoBase = styled.img`
  display: block;
  max-width: 200px;
  margin: 0 auto 24px auto;
  padding: 2px;
`;

const CdkLogo = styled.img`
  display: block;
  max-width: 200px;
  padding-left: 30px
`;

export const CdkLogo_blk = () => <CdkLogoBase src={logoBlack.default} />
export const CdkLogo_wht = () => <CdkLogo src={logoWhite.default} />